import {
  FACEBOOK_MESSENGER_SERVICE_NAME,
  INSTAGRAM_MESSENGER_SERVICE_NAME,
} from "../constants/AppConstants";
import { getFieldMappingTabConfig } from "../constants/fieldMappingConstants";

export const FIELD_MAPPING_EXCLUDED_LEFT_SERVICE_NAMES = ["teams_hellosend", "teams_helloSend", "hellosend", "standalone"];

export const normalizeMessengerServiceName = (serviceName) => {
  if (!serviceName) {
    return "";
  }
  if (serviceName === "instagram_messenger") {
    return INSTAGRAM_MESSENGER_SERVICE_NAME;
  }
  if (serviceName === "facebook_messenger") {
    return FACEBOOK_MESSENGER_SERVICE_NAME;
  }
  return serviceName;
};

export const resolveRightServiceNameFromIntegId = (integId, appProperties) => {
  if (!appProperties) {
    return "";
  }
  if (!integId) {
    return normalizeMessengerServiceName(appProperties?.rightServiceName || appProperties?.serviceName || "");
  }
  const installedAppServiceName = appProperties?.installedApps?.find(
    (installedApp) => installedApp?.integProps?.integId === integId
  )?.right?.service_name;
  if (installedAppServiceName) {
    return normalizeMessengerServiceName(installedAppServiceName);
  }
  const savedNumberServiceName = appProperties?.savedNumbers?.find(
    (savedNumber) => savedNumber?.integId === integId
  )?.serviceName;
  if (savedNumberServiceName) {
    return normalizeMessengerServiceName(savedNumberServiceName);
  }
  return normalizeMessengerServiceName(appProperties?.rightServiceName || appProperties?.serviceName || "");
};

export const resolveIntegIdFromFromNumber = (fromNumber, appProperties, savedNumbersList) => {
  const numbersList = savedNumbersList || appProperties?.savedNumbers || [];
  return numbersList.find((savedNumber) => savedNumber?.phoneNumber === fromNumber)?.integId ?? null;
};

export const isMessengerServiceName = (serviceName) => {
  const normalizedServiceName = normalizeMessengerServiceName(serviceName);
  return (
    normalizedServiceName === FACEBOOK_MESSENGER_SERVICE_NAME ||
    normalizedServiceName === INSTAGRAM_MESSENGER_SERVICE_NAME
  );
};

export const getMessengerServiceDisplayName = (serviceName) => {
  const normalizedServiceName = normalizeMessengerServiceName(serviceName);
  if (normalizedServiceName === INSTAGRAM_MESSENGER_SERVICE_NAME) {
    return "Instagram";
  }
  if (normalizedServiceName === FACEBOOK_MESSENGER_SERVICE_NAME) {
    return "Facebook";
  }
  return "Messenger";
};

export const getMessengerFieldMappingTab = (serviceName) => getFieldMappingTabConfig(serviceName);

export const isFieldMappingSupportedLeftService = (appProperties) => {
  const leftServiceName = (
    appProperties?.leftServiceName ||
    appProperties?.controller?.leftServiceName ||
    appProperties?.controller?.serviceName ||
    ""
  ).toLowerCase();
  if (!leftServiceName) {
    return true;
  }
  return !FIELD_MAPPING_EXCLUDED_LEFT_SERVICE_NAMES.some((excludedServiceName) =>
    leftServiceName.includes(excludedServiceName.toLowerCase().replace("_", ""))
  );
};

export const buildFieldMappingCacheKey = ({ leftServiceId, moduleName, serviceName, recordId }) =>
  [leftServiceId || "", moduleName || "", serviceName || "phone", recordId || ""].join("::");
